<template>
  <d-form @submit="doCreate">
    <div class="d-f-r d-fa-c d-fj-c">
      <img :src="value.thumb" alt="" style="height: 100px"/>
    </div>
    <d-form-input
        label="Material"
        class="mb-3"
        placeholder="Enter material"
        rules="required"
        v-model="form.material"
    />
    <d-form-input
        label="Size"
        class="mb-3"
        placeholder="Enter size"
        rules="required"
        v-model="form.size"
    />
    <d-form-select
        class="mb-3"
        v-model="form.designerId"
        label="Designer"
        placeholder="Choose designer"
        value-field="id"
        rules="required"
        text-field="name"
        :options="designerOptions"/>
    <div>
      <div class="mb-1">Note</div>
      <text-area
          placeholder="Enter note"
          :required="true"
          class="mb-3"
          v-model="form.note"
      />
    </div>
    <d-button
        type="primary"
        inputType="submit"
        text="Assign Now"
        :loading="loading"
        :block="true"
        class="btn btn-lg btn-block"
    />
  </d-form>
</template>

<script>
import LoadingContainer from "@/components/Misc/LoadingContainer";
import FormButton from "@/components/Form/FormButton";
import AlertBox from "@/components/Misc/AlertBox";
import Breadcrumb from "@/components/Common/Breadcrumb";
import OrderStatus from "@/components/Common/OrderStatus";
import Modal from "@/components/Misc/Modal";
import LinkButton from "@/components/Misc/LinkButton";
import InputText from "@/components/Form/InputText";
import InputSelect from "@/components/Form/InputSelect";
import TextArea from "@/components/Form/TextArea";
import Uuid from "@/components/Common/Uuid";
import TrackingInfo from "@/components/Common/TrackingInfo";
import LightBox from "vue-image-lightbox";
import SizeOption from "@/components/OrderItem/SizeOption";
import ColorOption from "@/components/OrderItem/ColorOption";
import FormGroup from "@/components/Form/FormGroup";
import ImageSelect from "@/components/Common/ImagePicker";
import ImagePicker from "@/components/Form/ImagePicker";
import FilePicker from "@/components/Common/FilePicker";
import embApi from "@/store/api/emb";
import ErrorDisplay from "@/components/Common/ErrorDisplay";
import UserApi from '@/store/api/user'
import DFormInput from "@/components/Form/DFormInput";
import DForm from "@/components/Form/DForm";
import DFormSelect from "@/components/Form/DFormSelect";
import DButton from "@/components/Common/DButton";

export default {
  name: "DesignAssignForm",
  components: {
    DButton,
    DFormSelect,
    DForm,
    DFormInput,
    ErrorDisplay,
    FilePicker,
    ImagePicker,
    ImageSelect,
    FormGroup,
    LoadingContainer,
    FormButton,
    AlertBox,
    Breadcrumb,
    OrderStatus,
    Modal,
    LinkButton,
    InputText,
    InputSelect,
    TextArea,
    Uuid,
    TrackingInfo,
    LightBox,
    SizeOption,
    ColorOption,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      form: {
        material: _.get(this.value, 'material'),
        designerId: _.get(this.value, 'designerId'),
        size: _.get(this.value, 'size'),
        note: _.get(this.value, 'note'),
      },
      error: {},
      loading: false,
      designerOptions: []
    }
  },
  watch: {
    form: {
      deep: true,
      handler(newVal) {
        this.validate(newVal)
      }
    }
  },
  mounted() {
    this.designerOptions = this.getDesignerOptions()
  },
  methods: {
    validate(form) {
      let status = true;
      const error = {}
      if (!form.material) {
        error.material = ['can\'t be blank']
        status = false
      }
      if (!form.size) {
        error.size = ['can\'t be blank']
        status = false
      }
      if (!form.designerId) {
        error.designer = ['can\'t be blank']
        status = false
      }
      this.error = error
      return status;
    },
    async doCreate() {
      if (!this.validate(this.form)) {
        return;
      }
      this.loading = true
      const api = embApi(this.$store.dispatch)
      const {data} = await api.assignDesigner(this.value.id, this.form)
      this.$emit('input', data)
    },
    async getDesignerOptions() {
      this.designerOptions = await UserApi().getAll({role: 'designer'})
    }
  }
}
</script>